<template>
  <div>
    <Modal v-model="isShow" :mask-closable="false" @on-ok="ok" :loading="loading"
           :width="800"
           @on-cancel="cancel">

      <div slot="header" class="modal-header">添加个人预定单<span>{{projectName}}</span><span class="dot">.</span><span>{{data?data.stockNumber:''}}</span></div>
      <base-info ref="baseinfo" :projectFid="projectFid"></base-info>
      <rent-info :data="data" ref="rentinfo"
                 @projectName="setprojectName"
      ></rent-info>

    </Modal>
  </div>


</template>
<script>
  import BaseInfo from './BaseInfo'
  import RentInfo from './RentInfo'
  import {saveReservation} from "../../../../../api/book";
  import {formatDateTime} from "../../../../../utils/format";

  export default {
    name: ""   ,
    components:{
      BaseInfo,
      RentInfo
    },
    props:{
      n: {
        type: Number,
        default: 0
      },
      data:{
        type:Object,
        default:null
      }

    },
    watch:{
      n(){
        this.projectName=''
        this.$nextTick(()=>{
          this.$refs['rentinfo'].init()
          this.$refs['baseinfo'].init()
          this.isShow=true
        })
      }
    },
    data(){
      return {
        loading: true,
        isShow:false,
        projectName:'',
        projectFid:''
      }
    },
    methods:{
      setprojectName(value){
        this.projectName=value.projectName
        this.projectFid=value.projectFid

      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
     async ok(){
        let boolRentInfo= await  this.$refs['rentinfo'].validate()
        let boolBase= await this.$refs['baseinfo'].validate()

        if(!boolRentInfo || !boolBase){
          this.changeLoading()
          return
        }

        let baseData=this.$refs['baseinfo'].formData
        let rentData=this.$refs['rentinfo'].formData
        let params={
          "depositAccount": rentData.depositAccount,
          "houseRentPrice": rentData.houseRentPrice,
          "projectId": this.projectFid,
          // "projectName": "string",
          "rentEndDate": formatDateTime(rentData.conEndDate,false),
          "rentStartDate": formatDateTime(rentData.conStartDate,false),
          "rentType": rentData.conType,
          "reservationPersonalSubjectDto": {
            "brithDate": baseData.birthday,
            "certificatesCode": baseData.certNum,
            "certificatesType": baseData.certType,
            "customerUid": baseData.uid,
            "marriageStatus": baseData.marriage,
            "signGender": baseData.sex,
            "signName": baseData.name,
            "signNationality": baseData.nationality,
            "userPhone": baseData.phoneNum,
            "workType": baseData.jobCode
          },
          "reservationSignDate": formatDateTime(rentData.reservationSignDate,false),
          "roomNum": this.data.stockNumber,
          "stockFid": this.data.stockFid,
          "type": 1
        }
        saveReservation(params).then(res=>{
          this.$Message.success('预定成功')
          this.$emit('update')
          this.isShow=false

        }).catch(error=>{
          this.$Message.info('预定失败')
          this.isShow=false

        })
      },
      cancel(){

      }
    }

  }
</script>

<style scoped>


</style>
